<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <audio-uploader :tip="mediaConfig.audioTip"
                            :maxSize="mediaConfig.audioMaxSize"
                            :audioUrl="config[field.key]"
                            @uploaded="handleUpload"></audio-uploader>
            <p v-html="field.memo"></p>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

  import AudioUploader from '@/components/AudioUploaderNew.vue';

  export default {
    name: 'tms-type-video',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        mediaConfig: {
          audioTip: '格式要求：MP3， 大小不超过20M',
          audioMaxSize: 20
        }
      }
    },

    components: {
      AudioUploader
    },

    mounted() {

    },

    methods: {
      handleUpload(src) {
        this.$set(this.config, this.field.key, src);
      },
    }
  }

</script>
